<template>
  <v-container fluid class="dashboard fill-height d-block">
    <h1>This page will be implemented as soon as possible</h1>
  </v-container>
</template>
<script>
export default {
  name: "dashboard",
  components: {},
  data() {
    return {};
  },
  computed: {},
  mounted() {},
  methods: {}
};
</script>
<style scoped lang="scss">
@import "Dashboard";
</style>
